﻿import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailFakturaAktionKostenverteilung extends GuiDetailGeneric {
    constructor() {
        super("GuiDetailFakturaAktionKostenverteilung");
    }
}
